export const painPoints = [
  "Không nắm rõ nhân viên thực sự có những kỹ năng gì",
  "Đánh giá năng lực còn cảm tính, thiếu dữ liệu",
  "Khó xác định skill gap theo vai trò, dự án, chiến lược", 
  "Đào tạo dàn trải, không đo được hiệu quả",
  "Nhân sự thiếu lộ trình phát triển rõ ràng",
  "Thiếu dữ liệu tổng hợp để ra quyết định bố trí, sử dụng nhân sự"
];

export const features = [
  {
    title: "Skill Framework & Taxonomy",
    description: "Thư viện kỹ năng chuẩn hóa theo ngành",
    detail: "Xây dựng hệ thống phân loại kỹ năng thống nhất, tùy biến theo doanh nghiệp. Tạo 'ngôn ngữ chung' về năng lực trong toàn tổ chức.",
    icon: "ri-organization-chart",
    features: [
      "Thư viện kỹ năng chuẩn (technical, soft skill, business)",
      "Phân loại: Hard Skills, Soft Skills, và Meta Skills",
      "Tùy biến theo từng doanh nghiệp, ngành nghề"
    ],
    conclusion: "Tạo \"ngôn ngữ chung\" về năng lực trong toàn tổ chức"
  },
  {
    title: "Hồ Sơ Năng Lực (Skill Profile)",
    description: "Thay thế CV tĩnh bằng Skill Passport động",
    detail: "Hồ sơ năng lực cập nhật theo thời gian thực, tích hợp bằng chứng kỹ năng từ dự án, chứng chỉ và đánh giá.",
    icon: "ri-user-settings-line",
    features: [
      "Hồ sơ skill động theo thời gian",
      "Tự khai báo, quản lý xác thực, bằng chứng kỹ năng",
      "Gắn skill với dự án, chứng chỉ, kết quả đánh giá"
    ],
    conclusion: "Thay CV tĩnh bằng Skill Passport"
  },
  {
    title: "Đánh Giá Kỹ Năng (Assessment)",
    description: "Đánh giá năng lực khách quan, có kiểm chứng",
    detail: "Kết hợp tự đánh giá, đánh giá quản lý và xác thực qua dự án thực tế. Biết chính xác nhân viên làm được gì.",
    icon: "ri-test-tube-line",
    features: [
      "Tự đánh giá & Quản lý đánh giá: Nhân viên tự chấm điểm và quản lý trực tiếp duyệt",
      "Xác thực qua dự án (Work Sample): Tích hợp dữ liệu từ Jira/Github",
      "Bài kiểm tra tự động: Tạo các bài kiểm tra/tình huống thực tế",
      "Đánh giá năng lực thực tế, không cảm tính"
    ],
    conclusion: "Biết chính xác nhân viên làm được gì"
  },
  {
    title: "Skill Gap Analysis",
    description: "Phân tích khoảng cách kỹ năng toàn diện",
    detail: "Dashboard trực quan hiển thị skill gap theo cá nhân, team và doanh nghiệp. Dữ liệu để ra quyết định chiến lược.",
    icon: "ri-bar-chart-box-line",
    features: [
      "Phân tích theo: Cá nhân, Team, Phòng ban, Doanh nghiệp",
      "Dashboard trực quan, heatmap kỹ năng",
      "Nhận diện skill thiếu hụt trọng yếu"
    ],
    conclusion: "Dữ liệu để ra quyết định chiến lược nhân sự"
  },
  {
    title: "Skill-Job-Project Mapping",
    description: "Đúng người - đúng việc - đúng kỹ năng",
    detail: "Định nghĩa yêu cầu kỹ năng cho từng vai trò, hỗ trợ phân công dự án và tuyển dụng nội bộ hiệu quả.",
    icon: "ri-mind-map",
    features: [
      "Định nghĩa yêu cầu kỹ năng cho từng vai trò",
      "So sánh năng lực thực tế với yêu cầu công việc",
      "Hỗ trợ phân công dự án & tuyển dụng nội bộ"
    ],
    conclusion: "Đúng người – đúng việc – đúng kỹ năng"
  },
  {
    title: "Learning Recommendation",
    description: "Đào tạo đúng trọng tâm, đo được hiệu quả",
    detail: "Gợi ý khóa học dựa trên skill gap, theo dõi tiến trình và đánh giá hiệu quả sau đào tạo.",
    icon: "ri-book-open-line",
    features: [
      "Gợi ý khóa học theo skill gap",
      "Theo dõi tiến trình phát triển năng lực",
      "Đánh giá hiệu quả sau đào tạo"
    ],
    conclusion: "Đào tạo đúng trọng tâm, đo được hiệu quả"
  },
  {
    title: "Career Path & Mobility",
    description: "Lộ trình nghề nghiệp minh bạch",
    detail: "Xây dựng con đường thăng tiến dựa trên năng lực thực, khuyến khích luân chuyển và giữ chân nhân tài.",
    icon: "ri-route-line",
    features: [
      "Lộ trình nghề nghiệp dựa trên skill",
      "Điều kiện thăng tiến minh bạch",
      "Khuyến khích luân chuyển & giữ chân nhân tài"
    ],
    conclusion: "Phát triển sự nghiệp gắn với năng lực thực"
  }
];
